module.exports = __webpack_public_path__ + "static/media/logo.53706e50.png";